module.exports = __webpack_public_path__ + "rotterdam-d51b41ca357864331429c1f9371a834e.bundle.jpg";